import { mergeWith } from "lodash-es";
/**
 * Merges design-system values. Only plain Object values will be merged recursively,
 * all other values will be merged by assignment.
 *
 * This function returns a new object
 */
export function mergeDesignSystem(original, overrides) {
    return mergeWith({}, original, overrides, (objValue, srcValue) => {
        if (Array.isArray(srcValue)) {
            return srcValue;
        }
    });
}
